export const I18N = {
    de: {
        contentTypeNotSupported: 'Das Dateiformat wird nicht unterstützt: ',
        fileTooLarge: 'Die Datei ist zu groß: ',
        uploadError: 'Es gab ein Problem beim Upload der Datei: ',
        delete: 'Löschen',
        dropZone: 'Ziehen Sie Ihre Datei per Drag-and-drop in dieses Feld.',
        maxFileSizeText: 'Die maximale Dateigröße beträgt',
        acceptText: 'Es sind nur Dateien in folgendem Format erlaubt:',
        tooMuchFiles: 'Die maximale Anzahl an Dateien beträgt ',
        selectFile: 'Datei auswählen',
        removeFile: 'Datei löschen',
    },
    en: {
        contentTypeNotSupported: 'The file format is not supported: ',
        fileTooLarge: 'The file is too large: ',
        uploadError: 'There was a problem uploading the file: ',
        delete: 'Delete',
        dropZone: 'Drag-and-drop your file into this field',
        maxFileSizeText: 'The maximum file size is',
        acceptText: 'Only files with the following format are allowed:',
        tooMuchFiles: 'The maximum number of files is ',
        selectFile: 'Select file',
        removeFile: 'Remove file',
    }
};
